import Loading from '../../shared/Loading/Loading';
import Auth from '../../modules/auth/Auth';
import Init from './hooks/Init';
import MessageModal from './components/MessageModal';
import PrincipalView from './components/PrincipalView/PrincipalView';

const Principal = () => {
  const vm = Init()
  return (
    <div className={`${vm.authView === 'createAccount' ? 'min-h-screen' : 'h-screen overflow-hidden'} bg-gray-100`}>
      {vm.loading ? (
        <div className="flex items-center justify-center min-h-screen">
          <Loading size="28" colorBase="gray-100" colorAccent="personalized" double={true} bold="8" />
        </div>
      ) : (
        <>
          {vm.currentUser ? (
            <PrincipalView
              init={vm.init}
              activeTab={vm.activeTab}
              permission={vm.permission}
              currentUser={vm.currentUser}
              initView={vm.initView}
              losesAccess={vm.losesAccess}
              setActiveTab={vm.setActiveTab}
              expireSesion={vm.expireSesion}
              updateMessage={vm.updateMessage}
              setCurrentUser={vm.setCurrentUser}
              closeSession={vm.closeSessionReturn}
            />
          ) : (
            <Auth
              authView={vm.authView}
              resetCode={vm.resetCode}
              permission={vm.permission}
              losesAccess={vm.losesAccess}
              setAuthView={vm.setAuthView}
              expireSesion={vm.expireSesion}
              updateMessage={vm.updateMessage}
              handleLogin={vm.handleLoginReturn}
            />
          )}
        </>
      )}
      <MessageModal
        messages={vm.messages}
        topOffsetPx={vm.topOffsetPx}
        maxHeightPx={vm.maxHeightPx}
        closeMessage={vm.closeMessage}
        messagesContainerRef={vm.messagesContainerRef}
      />
    </div>
  );
};

export default Principal;
